import { useSelector } from 'react-redux';

export const MakeFields = () => {
  const { rut } = useSelector((state) => state.issuesSlice);

  return [
    {
      name: 'rut',
      inputAdornment: '',
      label: 'RUT',
      textArea: '',
      disabled: true,
      required: true,
      value: rut,
      helper: 'Sin puntos, pero con guión Ej: 12345678-9',
    },
    {
      name: 'clientName',
      inputAdornment: '',
      label: 'Nombre completo',
      textArea: '',
      disabled: false,
      required: true,
      helper: '',
    },
    {
      name: 'phone',
      inputAdornment: '',
      label: 'Teléfono',
      textArea: '',
      disabled: false,
      required: true,
      helper: 'Ingresar 9 dígitos',
    },
    {
      name: 'email',
      inputAdornment: '',
      label: 'Correo actual',
      textArea: '',
      disabled: false,
      required: true,
      helper: '',
    },
    {
      name: 'newEmail',
      inputAdornment: '',
      label: 'Correo nuevo',
      textArea: '',
      disabled: false,
      required: true,
      helper: '',
    },
    {
      name: 'comment',
      multiline: true,
      rows: 4,
      inputAdornment: '',
      label: 'Escribir comentario',
      textArea: 'Escribir comentario',
      disabled: false,
      required: false,
      helper: '',
    },
  ];
};
